import type { ToggleProps } from '@react-types/checkbox';
import { ReactNode } from 'react';

import { FontSize } from '../../utils/typography';
import { AccessibleOnChange } from '../../utils/useAccessibleOnChange';

export const CheckboxAlign = {
	Left: 'left',
	Center: 'center',
	Right: 'right',
} as const;
export type CheckboxAlignment = (typeof CheckboxAlign)[keyof typeof CheckboxAlign];

export const CheckboxVerticalAlign = {
	Center: 'center',
	Top: 'top',
} as const;
export type CheckboxVerticalAlignment = (typeof CheckboxVerticalAlign)[keyof typeof CheckboxVerticalAlign];

export type CheckboxProps = Omit<ToggleProps, 'isSelected' | 'onChange' | 'name' | 'onBlur' | 'onFocus'> & {
	checked?: ToggleProps['isSelected'];
	onChange?: AccessibleOnChange<HTMLInputElement>;
	name: string;
	alignment?: CheckboxAlignment;
	onFocus?: React.FocusEventHandler<HTMLInputElement>;
	onBlur?: React.FocusEventHandler<HTMLInputElement>;
	id?: string;
	textSize?: FontSize;
	className?: string;
	disabled?: boolean;
	onClick?: React.HTMLAttributes<HTMLLabelElement>['onClick'];
	isStrong?: boolean;
	isValid?: boolean;
	errors?: string[];
	showValidation?: boolean;
	verticalAlignment?: CheckboxVerticalAlignment;
	isHorizontalError?: boolean;
} & ( // You must pass at least one of children/aria-label/aria-labelledby
		| {
				/**
				 * children should be used to label the input (either as a plain string, or as a rich ReactNode)
				 */
				children: ReactNode;
				'aria-label'?: string;
				'aria-labelledby'?: string;
		  }
		| {
				children?: ReactNode;
				'aria-label': string;
				'aria-labelledby'?: string;
		  }
		| {
				children?: ReactNode;
				'aria-label'?: string;
				'aria-labelledby': string;
		  }
	);
